<form [formGroup]="changePasswordForm" (ngSubmit)="submitHandler()">
  <!-- New Password -->
  <app-password-field label="{{'CHANGE_PASSWORD.NEW_PASSWORD' | translate}}"
    [placeholder]="'LOGIN.PLACEHOLDER' | translate" [control]="newPasswordControl"
    [hasError]="confirmPasswordControl.value && !passwordsMatch || newPasswordControl.errors?.['apiError']">
  </app-password-field>

  <!-- Password error from api -->
  <p *ngIf="newPasswordControl?.errors?.['apiError']" class="text-(--color-error) text-sm leading-5 font-normal mt-2">
    {{ newPasswordControl.errors?.['apiError'] }}
  </p>


  <!-- Password Rules -->
  <ul class="mt-6 space-y-4">
    <li *ngFor="let rule of ruleList" [ngClass]="{
          'text-(--text-muted)': !changePasswordForm.get('newPassword')?.value,
          'text-(--text-primary)': changePasswordForm.get('newPassword')?.value
        }" class="flex items-center text-base font-medium leading-6 gap-3">
      <img [src]="
          !changePasswordForm.get('newPassword')?.value
            ? icons.muted
            : (getRuleStatus(rule.key) ? icons.valid : icons.invalid)
        " alt="status icon">
      <span>{{ rule.label | translate}}</span>
    </li>
  </ul>

  <!-- Confirm Password -->
  <app-password-field label="{{'CHANGE_PASSWORD.CONFIRM_PASSWORD' | translate}}"
    [placeholder]="'LOGIN.PLACEHOLDER' | translate" [control]="confirmPasswordControl" customClass="mt-6"
    [hasError]="confirmPasswordControl.value && !passwordsMatch">
  </app-password-field>

  <!-- Password error match message -->
  <p *ngIf="confirmPasswordControl.value && !passwordsMatch"
    class="text-(--color-error) text-sm leading-5 font-normal mt-2">
    {{'CHANGE_PASSWORD.PASSWORD_MISMATCH' | translate}}
  </p>

  <!-- Submit Button -->
  <app-button text="{{'CHANGE_PASSWORD.CONFIRM' | translate}}" type="submit" variant="primary" size="lg"
    extraClass="my-10" [disabled]="!isFormValid">
  </app-button>
</form>